// extracted by mini-css-extract-plugin
export default {"RemoveCustomerButtonContainer":"RemoveCustomerModal_RemoveCustomerButtonContainer__jlTVZ","RemoveCustomerButtonElement":"RemoveCustomerModal_RemoveCustomerButtonElement__x7Rfm"};